import script from "./AppSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSelect.vue?vue&type=script&setup=true&lang=ts"

import "./AppSelect.vue?vue&type=style&index=0&id=6929202c&lang=scss"

const __exports__ = script;

export default __exports__